import BordableProperty from '../BordableProperty';

export default class PageSettingsProperty extends BordableProperty {

    constructor(opts = {}) {
        super();

        this.borderWidth.value = 0;
        this.backgroundColor.value = "#FFFFFF";

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }

    toString() {
        return "设置";
    }

    toStyle() {
        return {
            ...super.toStyle(),
            boxShadow: '5px 5px 5px 0px #00000024',
        }
    }
}
